import React, { forwardRef, useEffect, useState } from "react";
import TableFormSummary from "@sg/components/TableFormSummary";
import { Form } from "tea-component";
import './index.scss';

function GrManagementFrom(props: any, ref: any) {
    const { 
        data, 
        onChange = (value: any) => {
            console.log('GrManagementFrom onChange:', value);
        },
        renderGateReviewTag,
        tableStyle = {}
    } = props;
    const [tableData, setTableData] = useState<any>(data);
    
    // 监听data变化，同步到tableData
    useEffect(() => {
        if (data && Object.keys(data).length > 0) {
            setTableData(data);
        }
    }, [data?.milestone_id]);
    
    // 解析附件并将file属性改为name
    const parseAttachments = (attachmentsStr: string) => {
        if (!attachmentsStr || attachmentsStr.trim() === '') return [];
        try {
            const parsed = JSON.parse(attachmentsStr);
            if (Array.isArray(parsed)) {
                return parsed.map(item => ({
                    ...item,
                    name: item.file,  // 将file改为name
                    // 保留原有的path和url
                }));
            }
            return [];
        } catch (error) {
            console.error('Error parsing attachments:', error);
            return [];
        }
    };
    
    const GRData = {
        agent: 'text',
        content: tableData?.gate_review_decision || '',
        files: parseAttachments(tableData?.gr_attachments || '[]')
    };
    const KFData = {
        agent: 'text',
        content: tableData?.key_feedback || '',
        files: parseAttachments(tableData?.kf_attachments || '[]')
    };
    
    const onGRDecisionChange = (value: any) => {
        // 将name转换回file格式
        const files = value.files?.map((f: any) => ({
            file: f.name,
            path: f.path || f.url
        })) || [];
        
        // 基于最新的tableData更新
        const updatedData = {
            ...tableData,
            gate_review_decision: value.content,
            gr_attachments: JSON.stringify(files),
        };
        
        setTableData(updatedData);
        onChange(updatedData);
    };
    
    const onKeyFeedbackChange = (value: any) => {
        // 将name转换回file格式
        const files = value.files?.map((f: any) => ({
            file: f.name,
            path: f.path || f.url
        })) || [];
        
        // 基于最新的tableData更新
        const updatedData = {
            ...tableData,
            key_feedback: value.content,
            kf_attachments: JSON.stringify(files),
        };
        
        setTableData(updatedData);
        onChange(updatedData);
    };

    return (<>
        <Form style={{ width: '100%' }} className="dbs-gr-management-form">
            <Form.Item label="Gate Review Decision">
                {renderGateReviewTag && renderGateReviewTag(tableData?.gate_review)}
                <TableFormSummary 
                    domain="mgmt/studio/in_dev/gr_management"
                    data={GRData} 
                    showTitleInput={false} 
                    onChange={onGRDecisionChange}
                    uniqueId={`gr-decision-${tableData?.milestone_id}`}
                    style={tableStyle}
                />
            </Form.Item>

            <Form.Item label="Key Feedback">
                <TableFormSummary 
                    domain="mgmt/studio/in_dev/gr_management"
                    data={KFData} 
                    showTitleInput={false} 
                    onChange={onKeyFeedbackChange}
                    uniqueId={`key-feedback-${tableData?.milestone_id}`}
                    style={tableStyle}
                />
            </Form.Item>

            {/* 在 GrManagementFrom 里再加一个“占位” Form.Item 避免被全局样式干扰间距*/}
            <Form.Item style={{ display: 'none' }}></Form.Item>
        </Form>
    </>)
}

export default forwardRef(GrManagementFrom);